import { useAutoAnimate } from "@formkit/auto-animate/react"
import { useEffect, useState } from "react"
import { PROVIDERS, WeekPlanProps } from "../../config"
import Card from "./Card"
import { clsx } from "clsx"
import { updateIframeHeight } from "../../helper"

interface TileProps {
	day: WeekPlanProps
}
const Tile: React.FC<TileProps> = ({ day }) => {
	const [isOpen, setIsOpen] = useState<boolean>(false)
	const [animationRef] = useAutoAnimate<HTMLDivElement>()

	useEffect(() => {
		setTimeout(() => updateIframeHeight(), 1000)
	}, [isOpen])

	function toggleContent() {
		const newState = !isOpen
		setIsOpen(newState)
	}
	return (
		<section className="max-w-6xl mx-auto mb-6">
			<div className="bg-yellow border-4 border-white rounded-2xl p-4 w-full tileShadow">
				<div className="grid grid-cols-3 md:grid-cols-[150px_1fr_1fr] gap-6 w-full items-top">
					<div className="relative">
						<div className="scale-[0.65] origin-top-left absolute left-0 top-0 w-full -rotate-6 translate-y-2 tilehook">
							<Card cardKey={day.provider} front={<img src={"images/providers/" + day.provider + "-tile.png"} alt="" />} />
						</div>
						<div className="scale-[0.65] origin-right ">
							<Card cardKey={day.provider} front={<img src={"images/providers/" + day.provider + "-tile.png"} alt="" />} />
						</div>
					</div>
					<div className="col-span-2">
						<h3 className="font-Amsi text-[23px] lg:text-[37px] uppercase text-red leading-snug pb-0 mb-0">{day.shortTextHeadline}</h3>
						<div className="text-white text-[16px] lg:text-[20px] mb-1 font-Museo">{day.shortText}</div>
						<div className="font-Amsi uppercase text-red/80 text-right cursor-pointer lg:text-[28px]" onClick={toggleContent}>
							{isOpen ? "weniger" : "mehr"} erfahren
							<svg
								className={clsx("inline-block ml-2 -translate-y-[2px]", isOpen && "rotate-180")}
								width={23}
								height={15}
								viewBox="0 0 23 15"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<g clipPath="url(#clip0_345_10013)">
									<mask id="mask0_345_10013" style={{ maskType: "luminance" }} maskUnits="userSpaceOnUse" x={0} y={0} width={23} height={15}>
										<path
											d="M21.9107 0.86C20.5707 0.05 17.4807 0.86 10.9007 0.86C4.32071 0.86 0.0207062 0.45 0.0207062 2.49C0.0207062 4.53 0.560707 4.66 2.30071 6.56C4.05071 8.46 7.40071 11.98 9.02071 13.47C10.6307 14.96 11.3007 14.96 13.9907 12.66C16.6807 10.36 17.0807 9.68 20.1707 6.56C22.0307 4.68 22.7707 3.29 22.7707 2.31C22.7707 1.66 22.4507 1.18 21.9107 0.86Z"
											fill="white"
										/>
									</mask>
									<g mask="url(#mask0_345_10013)">
										<path d="M27.7707 19.5V-4.5L-4.97929 -4.5V19.5L27.7707 19.5Z" fill="#EB610D" />
									</g>
								</g>
								<defs>
									<clipPath id="clip0_345_10013">
										<rect width={14} height="22.75" fill="white" transform="matrix(0 1 -1 0 22.7707 0.5)" />
									</clipPath>
								</defs>
							</svg>
						</div>
					</div>
				</div>
				<div ref={animationRef}>{isOpen && <div className="text-white font-Museo">{day.text}</div>}</div>
			</div>
		</section>
	)
}

export default Tile
